import { useAccountAccess } from "@hooks/useAccountAccess";
import { TEAMS_MANAGED_BY_ORGANIZATION } from "./helpers";
import { isUserIdsIncluded } from "./utils/isUserIdsIncluded";
import { useUserProfileData } from "./utils/useUserProfileData";

export const useTeamsManagedByOrganization = () => {
  const userData = useUserProfileData();
  const { isImpersonatedByWingspanAdmin } = useAccountAccess();

  // Impersonating admins bypass the external-management lockout.
  if (isImpersonatedByWingspanAdmin) {
    return false;
  }

  const isTeamsManagedByOrganization = isUserIdsIncluded(
    userData,
    TEAMS_MANAGED_BY_ORGANIZATION
  );

  return isTeamsManagedByOrganization;
};
